import * as React from "react";

import { formatDate } from "app/utils/filters";
import BackOfficeAndSnapminLink from "app/components/BOComponents/BackOfficeAndSnapminLink";
import SnapminLink from "app/components/BOComponents/SnapminLink";
import { ColumnConfig } from "app/components/AppComponents/ConfigurableTable";
import MerchantPopover from "./MerchantPopover";
import { withStyles, Tooltip } from "@material-ui/core";
import stringToColor from "app/utils/stringToColour";

const styles = theme => ({
  dot: {
    margin: theme.spacing.unit / 8,
    height: "10px",
    width: "10px",
    border: "solid",
    borderWidth: "thin",
    borderRadius: "50%",
    display: "inline-block"
  },
  popper: {
    color: "black"
  },
  tooltip: {
    fontSize: "0.8em"
  }
});

const CustomTooltip = withStyles(styles)(Tooltip);

function PoppingDot(props) {
  return (
    <CustomTooltip title={props.title}>
      <span className={props.classes.dot} style={{ ...props.style }}></span>
    </CustomTooltip>
  );
}

const StyledDot = withStyles(styles)(PoppingDot);

const columnConfigs: ColumnConfig[] = [
  {
    name: "Date",
    render: row => formatDate(row.created_at)
  },
  {
    name: "Name",
    render: row => (
      <MerchantPopover data={row}>
        <BackOfficeAndSnapminLink
          backofficeUrl={`/snapscan/ops/merchants/${row.id}/payments`}
          snapminUrl={row.snapmin_url}
        >
          {row.name}
        </BackOfficeAndSnapminLink>
      </MerchantPopover>
    )
  },
  {
    name: "Tags",
    render: row => {
      return row.tags.map(tag => {
        const color = stringToColor(tag);
        return (
          <StyledDot
            key={tag}
            title={tag}
            style={{
              backgroundColor: color,
              borderColor: color
            }}
          ></StyledDot>
        );
      });
    }
  },
  {
    name: "Email",
    render: row => row.email
  },
  {
    name: "Snapmin",
    render: row => <SnapminLink snapminUrl={row.snapmin_url} />
  }
];

export default columnConfigs;
